import { buildApiUrl } from '@/utils/apiBase'
import { MEMBERS_BUNDLE_FINGERPRINT } from '../bundleFingerprint'

const startedAt = Date.now()
const emitted = new Set()

export function safeAuthErrorCode(error) {
  const code = String(error?.error || error?.code || error?.name || '').toLowerCase()
  if (code.includes('login_required')) return 'login_required'
  if (code.includes('consent_required')) return 'consent_required'
  if (code.includes('missing_refresh_token')) return 'missing_refresh_token'
  if (code.includes('organization') || code.includes('organisation')) return 'organisation_mismatch'
  if (code.includes('timeout')) return 'timeout'
  return 'sdk_failure'
}

export function emitAuthBootstrapDiagnostic(clubCode, payload, { onceKey } = {}) {
  if (!/^\d{6}$/.test(String(clubCode || ''))) return Promise.resolve(false)
  const key = onceKey || `${payload.event}:${payload.routeKey || ''}:${payload.safeErrorCode || ''}`
  if (emitted.has(key)) return Promise.resolve(false)
  emitted.add(key)
  return fetch(buildApiUrl(`/api/members-portal/${encodeURIComponent(clubCode)}/auth-bootstrap-diagnostic`), {
    method: 'POST', cache: 'no-store', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ timestampOffsetMs: Math.min(Date.now() - startedAt, 3_600_000), bundleVersion: MEMBERS_BUNDLE_FINGERPRINT.otaVersion || 'unknown', bundleGitSha: MEMBERS_BUNDLE_FINGERPRINT.gitSha || 'unknown', safeErrorCode: 'none', routeKey: '', ...payload }),
  }).then((response) => response.ok).catch(() => false)
}

export function resetAuthDiagnosticDedupeForTest() { emitted.clear() }
